/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import {  useSelector } from 'react-redux';
import { ConvertToTitleCase } from '../../../../../CommonMethods/ConvertToTitleCase';
import { handleName } from '../../../../../CommonMethods/Keyshandler';

const Table = ({pageNumber, handleOnClickSort,addOpen,confirmationState, sortValue, setConfirmationState,email, branchName,type,editOpen,setEditOpen,editData,setEditData,
    handleEndpoint,handleOnCLickActivate,getBranch, List, searchParams
}) => {
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const ClassList = useSelector(state => state.ClassesSlice);
    // const { List} = ClassList;
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');
    const [activateOpen, setActivateOpen] = useState(false);

    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        if(!activateOpen){
            setSelectedIndex(null)
        }
    });

    /**
     * The function handles sorting based on a given key and current sort value.
     */
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return (
        <div className={`-mx-1`}>
            <div className={`flex overflow-auto ${List?.data?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1`} id = "search-result" >
                <table aria-label="Outside Table" className="w-full" id='admin-table'>
                    <thead>
                        <tr>
                            <th className={`${type === 'subjects'?'w-[17%]':'w-[20%]'}`} onClick={() => {handleSort('name')}}>
                                <span id="name">{ConvertToTitleCase(handleName(type))} Name
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            {type === 'subjects' &&<th class="w-[12%]">
                                <span >Type
                                </span>
                            </th>}
                            {type === 'classes' || type === 'sections' ?
                                <th class="w-[14%]" onClick={() => { handleSort('created_at') }}>
                                    <span id="created_at" >Created on
                                        <button type="button" class="pl-1.5 sortedIcon">
                                            <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "created_at" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon" />
                                        </button>
                                    </span>
                                </th> :
                                <th class="w-[14%]" onClick={() => { handleSort('created_at') }}>
                                    <span id="created_at" >Created on
                                        <button type="button" class="pl-1.5 sortedIcon">
                                            <img loading="lazy" decoding="async" src={branchUrl === null || branchUrl?.split("+")[0] === "created_at" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon" />
                                        </button>
                                    </span>
                                </th>
                            }
                            <th class="w-[16%]">
                                <span >Created by
                                </span>
                            </th>
                            <th class="w-[14%]">
                                <span >Updated on
                                </span>
                            </th>
                            <th class="w-[16%]">
                                <span >Updated by
                                </span>
                            </th>
                            <th class="w-[13%]" onClick={() => {handleSort('status')}}>
                                <span id="status" >Status
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "status" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[9%]">
                                <span class="flex items-center justify-center">Actions
                                </span>
                            </th>
                        </tr>
                        <tr aria-colspan="7" class="h-1">
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data.map((item , index = 0) => (
                            <Fragment key={item._id}>
                                <TableBody
                                    branchName={branchName}
                                    tableData={item}
                                    setConfirmationState={setConfirmationState}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List.data?.length}
                                    email={email}
                                    type={type}
                                    editOpen={editOpen}
                                    setEditOpen={setEditOpen}
                                    editData={editData}
                                    setEditData={setEditData}
                                    handleEndpoint={handleEndpoint}
                                    getBranch={getBranch}
                                    handleOnCLickActivate={handleOnCLickActivate}
                                    activateOpen={activateOpen}
                                    setActivateOpen={setActivateOpen}
                                />
                            </Fragment>
                        ))}
                        
                    </tbody>
                    {List?.data?.length === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No ${type} added yet.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}

export default Table;
